<template>
<ImageDescriptionForm></ImageDescriptionForm>
</template>

<script>
import ImageDescriptionForm from "@/apps/imageToDescription/ImageDescriptionForm.vue";

export default {
  name: 'ImageDescriptionApp',
  components: {ImageDescriptionForm}
}
</script>

<style>
</style>